import { useMemo } from 'react'

import { sectionsMap } from '@/components/sections'

import OverlayGallery from '../base/overlay-gallery'
import { cn } from '@/lib/utils'
import { WPPageData } from '@/types'

export type BuilderProps = {
  pageProps?: WPPageData
}

type BuilderSection = {
  acf_fc_layout: string
  theme?: string
  bgcolor?: string
  [key: string]: any
}

const Builder = ({ pageProps }: BuilderProps) => {
  const builder = useMemo<BuilderSection[]>(() => {
    const sections = pageProps?.acf?.builder || []
    return sections
  }, [pageProps])

  return (
    <>
      {builder.map(({ acf_fc_layout, ...section }: BuilderSection, index: number) => {
        const Section = sectionsMap[acf_fc_layout]

        return Section ? (
          <Section key={`section-${index}`} className={cn('relative')} {...section} />
        ) : null
      })}

      <OverlayGallery />
    </>
  )
}

export default Builder
